module.exports = __webpack_public_path__ + "img/level_txt_2.05bec96b.png";